/* eslint-disable max-len, indent, sonarjs/no-duplicate-string */

const hasContexts = (contexts: Array<string>) => contexts.every(context => window.contexts.includes(context));

import widgetsMgr from 'widgets/widgetsMgr';

widgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContexts(['checkout']),
    load: () =>
        Promise.all([import(/* webpackChunkName: 'checkout.widgets' */ './widgets/checkout/PaymentAccordionItemShopPay').then(d => d.default)]).then(
            deps => {
                const [PaymentAccordionItemShopPay] = deps;

                return {
                    listId: 'checkout.shoppay',
                    widgetsDefinition: () => [['paymentAccordionItemShopPay', PaymentAccordionItemShopPay, 'paymentAccordionItem']]
                };
            }
        )
});

widgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContexts(['pdp']),
    load: () =>
        Promise.all([import(/* webpackChunkName: 'pdp.widgets' */ './widgets/checkout/ShopPayBuyNow').then(d => d.default)]).then(deps => {
            const [ShopPayBuyNow] = deps;

            return {
                listId: 'checkout.shoppay',
                widgetsDefinition: () => [['shopPayBuyNow', ShopPayBuyNow]]
            };
        })
});
